import type { Step } from '@/types'

/** Objective-specific steps: Menopause (menopausa) */
export const menopauseSteps: Step[] = []
